import { ref } from 'vue';

// Event Bus centralizado para manejar actualizaciones de pacientes
class PatientEventBus {
  constructor() {
    this.subscribers = new Map();
  }

  // Suscribirse a cambios de un paciente específico
  subscribe(patientId, callback) {
    if (!this.subscribers.has(patientId)) {
      this.subscribers.set(patientId, new Set());
    }
    this.subscribers.get(patientId).add(callback);
    
    // Devolver función para desuscribirse
    return () => {
      const callbacks = this.subscribers.get(patientId);
      if (callbacks) {
        callbacks.delete(callback);
        if (callbacks.size === 0) {
          this.subscribers.delete(patientId);
        }
      }
    };
  }

  // Notificar cambios a todos los suscriptores de un paciente
  notify(patientId, updatedData) {
    const callbacks = this.subscribers.get(patientId);
    if (callbacks) {
      callbacks.forEach(callback => {
        try {
          callback(updatedData);
        } catch (error) {
          console.error('Error en callback de PatientEventBus:', error);
        }
      });
    }
  }

  // Limpiar suscripciones
  clear() {
    this.subscribers.clear();
  }
}

// Singleton del Event Bus
export const patientEventBus = new PatientEventBus();

// Estado reactivo para el paciente actual
export const currentPatientData = ref(null);

// Función utilitaria para actualizar datos del paciente
export const updatePatientData = (patientData) => {
  const sanitizedData = { ...patientData };
  if ('action' in sanitizedData) {
    delete sanitizedData.action;
  }
  currentPatientData.value = sanitizedData;
  patientEventBus.notify(patientData.id, patientData);
};
